import { WEBSITE_ORIGIN } from '../app/constants';

export const environment = {
  production: true,
  // Names an origin rather than staying relative so the browser and a server render hash
  // the same transfer cache key; `ssrApiInterceptor` swaps it back for the internal host.
  // Safe because nginx serves /api on this exact origin (www redirects to it, unknown
  // hosts get 444), so it stays same-origin and cookies are unaffected.
  apiHost: WEBSITE_ORIGIN,
  ssrApiHost: ``,
  // ssrApiHost: `http://localhost:3000`, // for local development
  useSsrApiInterceptor: true,
  pagesChangeTopic: 'pages_change',
};
